<div *ngIf="getAlertState()">
    <c-modal #dhabiPortalModal id="dhabiPortalModal" alignment="center" visible="'true'" [backdrop]="'static'" (visibleChange)="visibleChange($event)" id="dhabiPortalModal" name="dhabiPortalModal" >
    <c-modal-header>
        <h5 cModalTitle>{{alertHeaderText}}</h5>
        <button [cModalToggle]="dhabiPortalModal.id" cButtonClose></button>
    </c-modal-header>
    <c-modal-body>
        {{alertBodyText}}
    </c-modal-body>
    <c-modal-footer>
        <button (click)="hideAlert()" cButton color="secondary">
            {{closeButtonText}}
        </button>
        <button *ngIf="bShowSecondButton" (click)="secondButton()" cButton color="primary">
            {{secondButtonText}}
        </button>
    </c-modal-footer>
    </c-modal>
</div>